<template>
  <div class='content'>
    <Grid :name='$t("EvedPay Cards")'
          desc='Manage accounts, cards and transactions'
          search
          search-placeholder='My Accounts'
          :sort='{ Division: "asc" }'
          :endpoint="api.$.evedpaycard.accounts"
          alias='PaymentInvoiceList_SentInvoices'
          legacy
          fit-columns
          :tabs='tabs'
          footer
          totals
          ref='grid'
          @selectedRows="rowSelected"
          xadditional-filters='additionalFilters'
          :filter='defaultFilter'>
      <span slot="additionalButtons">
        <!--<TransferFunds v-if="hasAccountPermission('EvedPayCardViewReconcileClose') || hasAccountPermission('EvedPayCardAdministrator')"
                      @success="refresh"
                      :accountId="selectedObj.Id"
                      :balance="selectedObj.Available"
                      :division="{AccountId: selectedObj.Id,
                                  DivisionId: selectedObj.DivisionId,
                                  DivisionName: selectedObj.Division}"
                      />-->
        <AddFunding v-if="hasAccountPermission('EvedPayCardAdministrator')"
                    @success="refresh"
                    :accountId="selectedObj.Id"
                    :ids="selectedRows"
                    :disabled="actionDisabled('addFunding')"
                    :tooltip="actionDisabledReason('addFunding')" />
        <ed-button v-if="hasAccountPermission('EvedPayCardAdministrator')"
                   button-class="btn btn-actionbar"
                   @click="() => {accountRefillSettings.Visible = true}"
                   :ids="selectedRows"
                   :disabled="actionDisabled('refillSettings')"
                   v-tooltip="actionDisabledReason('refillSettings')"
                   @success="refresh">
          REFILL SETTINGS
        </ed-button>
        <!--<CloseAccount v-if="hasAccountPermission('EvedPayCardViewReconcileClose') || hasAccountPermission('EvedPayCardAdministrator')"
                      @success="refresh"
                      :accountId="selectedObj.Id"
                      :balance="selectedObj.Available"
                      :division="{AccountId: selectedObj.Id,
                                  DivisionId: selectedObj.DivisionId,
                                  DivisionName: selectedObj.Division}"
                      :ids="selectedRows"
                      :disabled="actionDisabled('closeAccount')"
                      :tooltip="actionDisabledReason('closeAccount')" />-->
      </span>
      <span slot="additionalLabel" class="form-group no-margin">
        <i class="fas fa-exclamation"></i>
        <span>&nbsp;</span>
        <label>Click column headers to apply filters</label>
      </span>
    </Grid>
    <ed-modal title="EvedPay Account Refill Settings" 
      :show="accountRefillSettings.Visible"
      @close="accountRefillSettings.Visible = false, accountRefillSettings.ActionDisabled = true" 
      primary-button="Save"
      :primaryButtonDisabled="accountRefillSettings.ActionDisabled"
      @validate="$refs.accountRefillSettingsComponent.save()"
      validation>
      <AccountRefillSettings ref="accountRefillSettingsComponent" :accountId="selectedObj.Id" slot="body" 
        @success="accountRefillSettings.Visible = false"
        @loaded="accountRefillSettings.ActionDisabled = false"
      />
    </ed-modal>  
  </div>
</template>

<script>

import DataSkybox from '@/components/_modules/Invoices/data-skybox'

import Grid from '@/components/Grid'
import model from './model.js'
import tabs from '@/components/_modules/Programs/Card-accounts/tabs'
import AddFunding from '@/components/_modules/Programs/Card-list/AddFunding.vue'
import CloseAccount from '@/components/_modules/Programs/Card-list/CloseAccount.vue'
import TransferFunds from './TransferFunds.vue'
import AccountRefillSettings from '@/components/_modules/Programs/Card-list/AccountRefillSettings.vue'

import config, { metaStatuses, cannotCancelReasons } from '@/components/_modules/Invoices/statuses'

const { additionalFilters, filters, isActiveFilter } = config

const defaultFilter = []

const cancelTooltip = 'Please select an account.'

export default {
  components: {
    DataSkybox,
    Grid,
    AddFunding,
    CloseAccount,
    AccountRefillSettings: AccountRefillSettings,
    TransferFunds
  },
  data() {
    return {
      additionalFilters,
      defaultFilter: this.$route.query.filter
        ? filters(this.$route.query.filter.split(','))
        : filters(defaultFilter),
      statuses: metaStatuses,
      model,
      tabs: tabs.tabs,
      rowClasses: {
        'negative-amount': params => (params.data || {}).TotalAmount < 0
      },
      selectedRows: [],
      selectedAll: null,
      asyncCancelInvoiceDisabledReason: cancelTooltip,
      fundingObj: {},
      selectedObj: {},
      accountRefillSettings: { Visible: false, ActionDisabled: true },
      showRefillSettings: false
    }
  },
  watch: {
    '$route.query.filter' (value, oldValue) {
      if (value && value !== oldValue) {
        this.$refs.grid.gridOptions.api.setFilterModel(null)
        this.defaultFilter = filters(value.split(','), {}, this.$route.query.filter && this.$route.query.filter.split(','))
        this.$refs.grid.gridOptions.api.setFilterModel(this.defaultFilter)
      }
    }
  },
  computed: {
  },
  methods: {
    rowSelected(event) {
      if (typeof event === 'boolean') {
        this.selectedAll = event
      } else {
        this.selectedRows = event
        this.fetchCancelReason()
      }
      if (this.selectedRows.length === 1) {
        this.selectedObj = this.selectedRows[0].data
        console.log(this.selectedObj)
      }
    },
    refresh() {
      this.$refs.grid.refreshGrid()
    },
    handleStatusFilter(status) {
      this.$router.push({
        query: {
          filter: undefined
        }
      })

      this.$refs.grid.gridOptions.api.setFilterModel(
        filters(
          [status],
          this.$route.query.filter
            ? {}
            : this.$refs.grid.gridOptions.api.getFilterModel()
        )
      )
    },
    statusActive(status) {
      if (!this.$refs.grid) return {}
      return isActiveFilter(
        status,
        this.$refs.grid.gridOptions.api.getFilterModel(),
        this.$route.query.filter && this.$route.query.filter.split(',')
      )
    },
    async fetchCancelReason() {
      if (!this.selectedRows.length || this.selectedRows.length > 1) {
        this.asyncCancelInvoiceDisabledReason = cancelTooltip
        return
      }

      const tooltip = await this.api.forms.post(this.api.$.invoice.list.canCancelInvoice,
        {
          id: this.selectedId
        })
      const reason = cannotCancelReasons[tooltip.data.SuccessMessage]
      this.asyncCancelInvoiceDisabledReason = reason || ''

      return reason
    },
    hasAccountPermission(permission) {
      if (this.$user && this.$user.$.userPermissions && this.$user.$.userPermissions.length !== 0) {
        return this.$user.$.userPermissions.includes(permission)
      }

      return false
    },
    actionDisabled(actionName) {
      return !!this.actionDisabledReason(actionName)
    },
    actionDisabledReason(actionName) {
      if (this.selectedRows.length > 1) {
        switch (actionName) {
          case 'addFunding':
            return 'You can only add funds for one account at a time.'
          case 'closeAccount':
            return 'You can only close one account at a time.'
          case 'refillSettings':
            return 'You can only refill one account at a time.'
          default:
            return cancelTooltip
        }
      }
      if (this.selectedRows.length === 0) {
        return cancelTooltip
      }
    },
    async addFunds() {
      if (this.fundingObj.amount && this.fundingObj.label) {
        var isImmediate = this.fundingObj.label === 'Immediate Funding'
        this.fundingObj.divisionId = this.selectedObj.DivisionId
        try {
          const response = await this.api.forms.post(`evedpaycards/accounts/${this.fundingObj.divisionId}/add-funding`, {
            Amount: parseFloat(this.fundingObj.amount),
            IsImmediate: isImmediate
          })

          if (response.status === 200) {
            this.refresh()
          }
        } catch (error) {
          console.error(error)
        }
      } else {
        this.addFundsError()
      }
      this.fundingObj = {}
    },
    addFundsError() {
      global.app.$notifications.notify({
        alert: true,
        type: 'plain',
        icon: 'exclamation-circle',
        placement: { from: 'top', align: 'center' },
        timeout: 0,
        message: 'Please fill out all the fields.'
      })
    },
    singularize(value) {
      return value.endsWith('s') ? value.slice(0, -1) : value
    }
  },
  created() {
    this.divisionsName = this.$root.getUser.settings.Labels.DivisionsName
    this.divisionName = this.singularize(this.$root.getUser.settings.Labels.DivisionName)
    this.model.Division.label = this.divisionName
  }
}

</script>

<style lang="scss" scoped>
@import "~@/assets/sass/_variables.scss";
@import "~@/components/_modules/Invoices/statuses.scss";

.grid >>> {
  .ag-row.negative-amount {
    @include theme {
      background-color: lighten(v(urgent-02), 45%);
    }
  }
}

.statuses-bar {
  line-height: 40px;
}

</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-accounts/index.vue